<template>
  <div class="package-manage">
    <div class="page-header">
      <van-icon name="arrow-left" size="24" class="back-icon" @click="goBack" />
      <h2 class="page-title">安装包管理</h2>
    </div>
    <div class="package-cards">
      <van-card v-for="item in packageTypes" :key="item.type" class="package-card" @click="goToUpload(item.type)">
        <template #title>
          <p class="packageTitle font18 b">{{ item.name }}</p>
        </template>
        <template #thumb>
          <van-icon :name="item.icon || 'apps-o'" size="40" />
        </template>
        <template #desc>
          <p class="card-desc">{{ item.description }}</p>
        </template>
      </van-card>
    </div>
  </div>
</template>

<script>
import { getPackageTypes } from '@/api/package'
export default {
  name: 'PackageManage',
  data() {
    return {
      packageTypes: []
    }
  },
  created() {
    this.fetchTypes()
  },
  methods: {
    async fetchTypes() {
      try {
        const res = await getPackageTypes()
        console.log('获取包类型响应:', res)
        const list = Array.isArray(res && res.data) ? res.data : []
        const iconMap = {
          pos_android: 'apps-o',
          kiosk: 'desktop-o',
          // Windows 使用 desktop 图标，更贴近 PC 端
          pos_windows: 'desktop-o',
          kds: 'tv-o',
          // 后端 value 为 'pos'，前端映射到安卓图标
          pos: 'apps-o'
        }

        this.packageTypes = list.map(item => {
          const type = item.type || item.value || item.key
          return {
            type,
            name: item.name,
            description: item.description,
            icon: (item.icon && String(item.icon)) || iconMap[type] || 'apps-o'
          }
        })
      } catch (e) {
        console.error('获取包类型失败:', e)
        this.$toast('获取包类型失败')
      }
    },
    goToUpload(type) {
      this.$router.push(`/package/upload/${type}`)
    },
    goBack() {
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="scss" scoped>
.package-manage {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  .back-icon {
    color: #2c3e50;
    cursor: pointer;
    padding: 8px;
    margin-right: 16px;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(25, 137, 250, 0.1);
      color: #1989fa;
    }
  }
}

.page-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 40px;
    height: 3px;
    background: #1989fa;
    border-radius: 2px;
  }
}

.package-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 0 10px;
  margin-top: 20px;
}

.package-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  :deep(.van-card__header) {
    padding: 0;
  }

  :deep(.van-card__thumb) {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f5ff;
    border-radius: 12px;
  }

  :deep(.van-card__content) {
    padding-left: 16px;
  }

  .packageTitle {
    margin-bottom: 8px;
    @include ellipsis(2);
  }

  :deep(.van-card__desc) {
    display: block;
    overflow: visible;
  }

  .card-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    white-space: normal;
    word-break: break-word;
  }

  :deep(.van-icon) {
    color: #1989fa;
  }
}

@media screen and (max-width: 1200px) {
  .package-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 992px) {
  .package-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .package-cards {
    grid-template-columns: 1fr;
  }
  .package-card {
    margin-bottom: 16px;
  }
}
</style>
